import React from 'react';
import clsx from 'clsx';
import InputField from 'shared/components/InputField';
import BestFitRegion from '../BestFitRegion';
import { ReactComponent as MapSearch } from 'assets/icons/map-search.svg';
import { ReactComponent as DeleteButton } from 'assets/icons/close_enclosed.svg';
import { FieldProps, RawMaterialProps } from 'enums/RawMaterialEnums';
import { FormikProps } from 'formik';
import { rawMaterialPayload, Origin } from 'views/CreateProductFlow/CreateProductFlowInterfaces';
import hasErrorAndTouched from 'shared/utils/hasErrorAndTouched';
import styles from '../CreateProductFlow.module.scss';

interface PackagingMaterialOriginFieldsProps {
  index: number;
  originIndex: number;
  isDisabled: boolean;
  formikProps: FormikProps<rawMaterialPayload>;
  fetchData: (params?: { 'input-field': string }) => void;
  showLocationModal: (
    originIndex: number,
    type: string,
    selectedIndexData?: Origin[],
    selectedRecordIndex?: number,
    selectedRecordType?: string,
    selectedOriginIndex?: number
  ) => void;
  handleRemoveOrigins: (
    formikProps: FormikProps<rawMaterialPayload>,
    index: number,
    originIndex: number,
    type?: string
  ) => void;
}

const PackagingMaterialOriginFields: React.FC<
  PackagingMaterialOriginFieldsProps
> = ({
  index,
  originIndex,
  isDisabled,
  formikProps,
  fetchData,
  showLocationModal,
  handleRemoveOrigins,
}) => {
  return (
    <div
      key={`${RawMaterialProps.MULTIPLE_ORIGIN}-${index}-${originIndex}`}
      className={styles.fieldRow}>
      <div className={styles.numberEmptyContainer}></div>
      <div className={styles.ingredientFieldContainer}></div>
      <div className={styles.bigFieldContainer}>
        <InputField
          name={`${RawMaterialProps.PACKAGE_MATERIAL}[${index}].${RawMaterialProps.ORIGINS}[${originIndex}].${RawMaterialProps.INGREDIENT_ORIGIN}`}
          label={FieldProps.INGREDIENT_ORIGIN_PLACEHOLDER}
          placeholderstring={FieldProps.INGREDIENT_ORIGIN_PLACEHOLDER}
          disabled={isDisabled}
          suffix={
            <span
              onClick={() =>
                !isDisabled &&
                showLocationModal(
                  originIndex,
                  `${RawMaterialProps.PACKAGE_MATERIAL}[${index}].${RawMaterialProps.ORIGINS}`,
                  formikProps?.values?.packageMaterials?.[index]?.origins,
                  index,
                  RawMaterialProps.PACKAGE_MATERIAL,
                  originIndex
                )
              }>
              <MapSearch />
            </span>
          }
          onFocus={() =>
            showLocationModal(
              originIndex,
              `${RawMaterialProps.PACKAGE_MATERIAL}[${index}].${RawMaterialProps.ORIGINS}`,
              formikProps?.values?.packageMaterials?.[index]?.origins,
              index,
              RawMaterialProps.PACKAGE_MATERIAL,
              originIndex
            )
          }
        />
      </div>
      <div className={styles.bigFieldContainer}>
        <BestFitRegion
          label={FieldProps.INGREDIENT_REGION_PLACEHOLDER}
          placeholder={FieldProps.INGREDIENT_REGION_PLACEHOLDER}
          disabled={isDisabled}
          onFocus={() => {
            fetchData({
              'input-field': 'production region',
            });
          }}
          name={`${RawMaterialProps.PACKAGE_MATERIAL}[${index}].${RawMaterialProps.ORIGINS}[${originIndex}].${RawMaterialProps.BEST_FIT_REGION}`}
          ingridientFieldName={`${RawMaterialProps.PACKAGE_MATERIAL}[${index}].${FieldProps.PACKAGING_NAME}`}
          errorMessageStyle={styles.errorMessage}
        />
      </div>
      <div className={styles.smallFieldContainer}>
        <InputField
          key={FieldProps.INGREDIENT_QUANTITY}
          name={`${RawMaterialProps.PACKAGE_MATERIAL}[${index}].${RawMaterialProps.ORIGINS}[${originIndex}].${RawMaterialProps.ORIGIN_SHARE}`}
          label={FieldProps.INGREDIENT_ORIGIN_SHARE_PLACEHOLDER}
          placeholderstring={FieldProps.INGREDIENT_ORIGIN_SHARE_PLACEHOLDER}
          disabled={isDisabled}
          onFocus={() => {
            fetchData({
              'input-field': RawMaterialProps.QUANTITY,
            });
          }}
        />
      </div>
      <div className={styles.smallFieldContainer}>
        <InputField
          key={FieldProps.INGREDIENT_UNIT}
          name={`${RawMaterialProps.PACKAGE_MATERIAL}[${index}].${RawMaterialProps.ORIGINS}[${originIndex}].${RawMaterialProps.PERCENTAGE}`}
          label={FieldProps.INGREDIENT_UNIT_PLACEHOLDER}
          placeholderstring={FieldProps.INGREDIENT_UNIT_PLACEHOLDER}
          disabled={true}
        />
      </div>
      {!isDisabled && (
        <div
          className={styles.deleteButton}
          onClick={() =>
            handleRemoveOrigins(
              formikProps,
              index,
              originIndex,
              RawMaterialProps.PACKAGE_MATERIAL
            )
          }>
          <DeleteButton
            className={clsx(
              hasErrorAndTouched(
                formikProps.errors.packageMaterials?.[index],
                formikProps.touched.packageMaterials?.[index],
                styles
              )
            )}
          />
        </div>
      )}
    </div>
  );
};

export default PackagingMaterialOriginFields;
